// extracted by mini-css-extract-plugin
export var linkText = "_qj-0";